export default "__VITE_ASSET__CZJbkPvX__"